import { t } from "@/lib/i18n/interpolate";
import {
  formatP,
  type NumberFormatter,
} from "@/lib/tool-kit/stats-tests/format";

/**
 * Below this, a studentized-range p-value is shown as a bound rather than a number.
 *
 * The upper tail is computed as 1 − P(Q ≤ q), exactly as R's `ptukey(lower.tail = FALSE)`
 * does, so its absolute error is about 1e-14. Four digits of a p near 1e-10 are still
 * sound; digits beyond that would be noise, so the table says "< 1 × 10⁻⁹" instead.
 */
export const RANGE_P_FLOOR = 1e-9;

/** `below` is a template such as "< {p}". */
export function formatRangeP(
  p: number,
  fmt: NumberFormatter,
  below: string
): string {
  if (p < RANGE_P_FLOOR) {
    return t(below, { p: formatP(RANGE_P_FLOOR, fmt) });
  }
  return formatP(p, fmt);
}
